<template>
    <div class="ringsLoading">
        <div class="container rings"></div>
        <span class="holdPlease">{{handleHoleOnInfo}}</span>
    </div>
</template>

<script>
import i18n from '@/i18n'
export default {
    name: "YeahagencyLoadingRings",

    data() {
        return {};
    },

    computed: {
        handleHoleOnInfo() {
            return i18n.t('public.pleaseHoldon')
        }
    },

    mounted() {

    },

    methods: {}
};
</script>

<style lang="less" scoped>
.ringsLoading {
    .holdPlease {
        position: absolute;
        top: 53%;
        left: 50%;
        transform: translateX(-50%);
    }

    /**
  * Rings
  *
  * @author jh3y - jheytompkins.com
*/
    @-webkit-keyframes rings {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }

        50%,
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @keyframes rings {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }

        50%,
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    .rings:after,
    .rings:before {
        -webkit-animation: rings 1s infinite linear;
        animation: rings 1s infinite linear;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border: 6px solid rgb(251, 223, 141);
        border-radius: 100%;
        content: "";
        height: 30px;
        left: 50%;
        margin-top: -15px;
        position: absolute;
        top: 50%;
        width: 30px;
    }

    .rings:after {
        border-left-color: #ffb902;
        margin-left: -2px;
    }

    .rings:before {
        animation-direction: reverse;
        border-right-color: #ffb902;
        margin-left: -28px;
    }
}
</style>



// WEBPACK FOOTER //
// src/directives/ringsLoading/ringsLoading.vue